import { render, staticRenderFns } from "./applyJoin.vue?vue&type=template&id=27f4c354&scoped=true"
import script from "./applyJoin.vue?vue&type=script&lang=js"
export * from "./applyJoin.vue?vue&type=script&lang=js"
import style0 from "./applyJoin.vue?vue&type=style&index=0&id=27f4c354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4c354",
  null
  
)

export default component.exports